export default "__VITE_ASSET__DjnGmw2V__"